import { render, staticRenderFns } from "./header-card.vue?vue&type=template&id=150f1c5d&scoped=true&"
import script from "./header-card.vue?vue&type=script&lang=js&"
export * from "./header-card.vue?vue&type=script&lang=js&"
import style0 from "./header-card.vue?vue&type=style&index=0&id=150f1c5d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "150f1c5d",
  null
  
)

export default component.exports